<template>
  <v-dialog
    :content-class="'technology-description-right'"
    :value="internalValue"
    :width="width"
    :hide-overlay='true'
    transition="slide-x-reverse-transition"
    @click:outside='onCloseClickButton'
    @keydown.esc="onCloseClickButton"
  >
    <div class='technology-description-right-popup'>
      <div class='technology-description-right-popup__action'>
        <span class='close_btn' @click='onCloseClickButton'>
          <span class="material-icons-outlined">
            close
          </span>
        </span>
      </div>
      <div class='technology-description-right-popup__content'>
        <div class='technology-description-right-popup__content__title'>
          <span class='technology-description-right-popup__content__title__icon'>
            <v-icon v-if="!technologiesData.icon" class="material-icons-outlined">widgets</v-icon>
            <v-img :src='technologiesData.icon'/>
          </span>
          <span class='technology-description-right-popup__content__title__name' :title='formattedNameAndVersion'>
            {{ formattedNameAndVersion }}
          </span>
        </div>
        <div class='technology-description-right-popup__content__description'>
          {{ technologiesData.description}}
        </div>
        <div class='technology-description-right-popup__content__link'>
          <a :href='actualLink' target='_blank'> {{technologiesData.link}} </a>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>

import indexDB from '@/assets/tech-metadata/index-db.json';
import technologiesKeys from '@/constants/technologies';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'TechnologyDescriptionRightPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    technologyItem: {
      type: Object,
      required: true,
    },
    internalValue: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    width() {
      return 382;
    },
    formattedNameAndVersion() {
      return this.technologyItem.name?.replace('/', ' ') || '';
    },
    technologiesData() {
      let searchName = this.technologyFormattedName;
      let metaDataSearch;
      let iconSearch;
      let techMetadata;
      let description;
      let link;
      let icon;
      if (this.technologyItem) {
        if (Object.keys(indexDB).includes(this.technologyFormattedName)) {
          if (Object.keys(indexDB[this.technologyFormattedName]).includes(technologiesKeys.ref)) {
            searchName = indexDB[this.technologyFormattedName][technologiesKeys.ref];
          }
          try {
            metaDataSearch = indexDB[searchName][technologiesKeys.metaData];
            iconSearch = indexDB[searchName][technologiesKeys.icon];
            // eslint-disable-next-line global-require,import/no-dynamic-require
            techMetadata = require(`@/assets/tech-metadata/${metaDataSearch}`);
            description = techMetadata.description;
            link = techMetadata.link;
          } catch (e) {
            description = '';
            link = '';
          }
          try {
            // eslint-disable-next-line global-require,import/no-dynamic-require
            icon = require(`@/assets/tech-metadata/${iconSearch}`);
          } catch (e) {
            icon = null;
          }
        }
        return {description, link, icon};
      }
      return null;
    },
    technologyFormattedName() {
      const techName = this.technologyItem.name?.split('/')[0];
      let formattedTechName = techName.toLowerCase().replace(' ', '-');
      if (Object.keys(indexDB).includes(formattedTechName)) {
        if (Object.keys(indexDB[formattedTechName]).includes(technologiesKeys.ref)) {
          formattedTechName = indexDB[formattedTechName][technologiesKeys.ref];
        }
      }
      return formattedTechName;
    },
    actualLink() {
      return this.technologiesData.link?.startsWith('https://')
        ? this.technologiesData.link
        : `https://${this.technologiesData.link}`;
    },
  },
  methods: {
    onCloseClickButton() {
      this.$emit('closed');
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.close_btn {
  margin-top: $space-2;
  float: right;

  &:hover {
    cursor: pointer;
  }
}

.v-dialog__content {
  align-items: stretch;
  justify-content: flex-end;
}

.technology-description-right-popup {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;

  &__content {
    display: flex;
    flex-direction: column;
    margin-left: $space-6;
    margin-right: $space-6;

    &__title {
      margin-bottom: $space-5;
      display: flex;

      &__icon {
        .v-image {
          max-width: $space-8;
        }

        .v-icon {
          margin-bottom: rem(-30);
          color: var(--text-primary);
        }
      }

      &__name {
        color: var(--text-primary);
        font-family: $default-application-font-bold;
        font-size: $font-size-md;
        font-weight: bold;
        letter-spacing: 0;
        margin-left: $space-2;
        max-width: 80%;
        text-transform: capitalize;
        align-self: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__description {
      text-transform: capitalize;
      color: var(--text-primary);
      font-family: $default-application-font-regular;
      font-size: $font-size-base;
      letter-spacing: 0;
      margin-left: $space-2;
      margin-bottom: $space-8;
      align-self: center;
    }

    &__link {
      color: var(--brand-secondary);
      font-family: $default-application-font-regular;
      font-size: $font-size-base;
      letter-spacing: 0;
      line-height: $space-4;
      margin-bottom: $space-8;
      margin-left: $space-2;
      max-width: 80%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>

<style lang='scss'>
@import '~@/assets/styles/design-system';

.technology-description-right.technology-description-right {
  margin: 0;
  max-height: 100%;
}
</style>
